import Form from './TextForm'
import isEmpty from './TextIsEmpty'
import Section from './TextSection'
import Thumbnail from './TextThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
